// Service types with detailed information
export const serviceTypes = {
  'ac-repair': [
    {
      id: 'split-ac',
      name: 'Split AC Repair',
      description: 'Expert repair and maintenance for all split AC units',
      features: ['Gas Refilling', 'PCB Repair', 'Compressor Repair', 'Coil Cleaning']
    },
    {
      id: 'window-ac',
      name: 'Window AC Repair',
      description: 'Complete servicing solutions for window air conditioners',
      features: ['Cooling Issues', 'Noise Problems', 'Water Leakage', 'Installation']
    },
    {
      id: 'inverter-ac',
      name: 'Inverter AC Repair',
      description: 'Specialized repair for inverter air conditioning systems',
      features: ['Power Issues', 'Temperature Control', 'Smart Features', 'Energy Efficiency']
    }
  ],
  'refrigerator-repair': [
    {
      id: 'single-door',
      name: 'Single Door Refrigerator',
      description: 'Expert repair for single door refrigerators',
      features: ['Cooling Issues', 'Thermostat Repair', 'Door Seal', 'Gas Charging']
    },
    {
      id: 'double-door',
      name: 'Double Door Refrigerator',
      description: 'Professional repair for frost-free refrigerators',
      features: ['Defrost System', 'Temperature Control', 'Ice Maker', 'Display Panel']
    },
    {
      id: 'side-by-side',
      name: 'Side by Side Refrigerator',
      description: 'Specialized repair for side by side models',
      features: ['Water Dispenser', 'Ice Maker', 'Digital Controls', 'Smart Features']
    }
  ],
  'washing-machine-repair': [
    {
      id: 'front-load',
      name: 'Front Load Washer',
      description: 'Expert repair for front loading washing machines',
      features: ['Drum Issues', 'Motor Problems', 'Door Lock', 'Control Board']
    },
    {
      id: 'top-load',
      name: 'Top Load Washer',
      description: 'Professional repair for top loading machines',
      features: ['Agitator Issues', 'Spin Problems', 'Timer Repair', 'Belt Replacement']
    },
    {
      id: 'fully-automatic',
      name: 'Fully Automatic Washer',
      description: 'Complete repair for fully automatic washers',
      features: ['Program Settings', 'Digital Display', 'Sensor Issues', 'Smart Features']
    }
  ],
  'tv-repair': [
    {
      id: 'led-tv',
      name: 'LED TV Repair',
      description: 'Expert repair for LED televisions',
      features: ['Display Issues', 'Backlight Problems', 'Sound Repair', 'Smart Features']
    },
    {
      id: 'lcd-tv',
      name: 'LCD TV Repair',
      description: 'Professional repair for LCD TV sets',
      features: ['Screen Problems', 'Power Issues', 'Picture Quality', 'HDMI Ports']
    },
    {
      id: 'smart-tv',
      name: 'Smart TV Repair',
      description: 'Specialized repair for Smart TVs',
      features: ['Network Issues', 'App Problems', 'Software Updates', 'Remote Control']
    }
  ],
  'water-purifier-repair': [
    {
      id: 'ro-system',
      name: 'RO System Repair',
      description: 'Expert repair for RO water purifiers',
      features: ['Filter Change', 'Membrane Issues', 'Low Pressure', 'TDS Control']
    },
    {
      id: 'uv-system',
      name: 'UV System Repair',
      description: 'Professional repair for UV purifiers',
      features: ['UV Lamp', 'Filter Issues', 'Water Flow', 'Electrical Problems']
    },
    {
      id: 'mineral-ro',
      name: 'Mineral RO Repair',
      description: 'Specialized repair for mineral RO systems',
      features: ['Mineralizer', 'TDS Controller', 'Taste Issues', 'Filter Change']
    }
  ]
} as const;

export type ServiceTypeId = keyof typeof serviceTypes;
export type ServiceType = typeof serviceTypes[ServiceTypeId][number];